import React from 'react'
import { useQuery } from '@apollo/client';
import {GET_NEUTERINGS} from "../../../queries/neuterings";
import {useTranslation} from "react-i18next";


const NeuteringSelect = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(GET_NEUTERINGS);

  if (loading) return  <p>Loading</p>;
  if (error) return <p>ERROR</p>;
  if (!data) return <p>Not found</p>;

  let optionsItems = (data.Neuterings || []).map((neutering) => {
    return (<option key={neutering.value} value={neutering.value}>{t(neutering.description)}</option>)
  })

  return (
    <select ref={ref} {...props} className="block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
      { optionsItems }
    </select>
  )
})

export default NeuteringSelect
